(() => {
  const elementName = "qk-long-form-review-player";

  if (customElements.get(elementName)) {
    return;
  }

  class QkLongFormReviewPlayer extends HTMLElement {
    connectedCallback() {
      if (this.dataset.playerReady === "true") {
        return;
      }

      const poster = this.querySelector("[data-qk-long-form-review-poster]");
      const template = this.querySelector("[data-qk-long-form-review-template]");

      if (!poster || !template) {
        return;
      }

      this.dataset.playerReady = "true";
      poster.addEventListener("click", () => this.loadVideo(template));
    }

    loadVideo(template) {
      if (this.hasAttribute("loaded")) {
        return;
      }

      const iframe = template.content.querySelector("iframe")?.cloneNode(true);

      if (!(iframe instanceof HTMLIFrameElement)) {
        return;
      }

      this.setAttribute("loaded", "true");
      this.appendChild(iframe);
      iframe.focus({ preventScroll: true });
    }
  }

  customElements.define(elementName, QkLongFormReviewPlayer);
})();
